var mentions_default = {
  "mentionPalette": "Nk2EV",
  "mention": "O5joz",
  "mentionViewer": "r-TG0",
  "mentionSuggestionsEntry": "UkHyq",
  "mentionSuggestionsEntryFocused": "wRUsY",
  "mentionSuggestionsEntryText": "r8d4q",
  "mentionSuggestionsEntryAvatar": "gNIE6",
  "mentionSuggestions": "G4ut3",
  "cursorDefault": "_27zJd",
  "cursorPointer": "kgDan"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
